import React from "react";
import CustomIcon from "components/CustomIcon";
import {useDispatch, useSelector} from "react-redux";
import {setShowTips} from "../../../redux/slices/manageBlogSlice";
import Backdrop from "../../../components/BackDrop";
import {blogContentValidityCheck} from "../../../helpers/helperFunctions";
import {MIN_CONTENT_NEEDED_IN_BLOGS} from "../constants";

const BlogTips = () => {
  const show = useSelector((state) => state.manageBlogs.showTips);


  const dispatch = useDispatch();

  const closeTips = () => {
    dispatch(setShowTips({show: false}));
  };
  return (
    <>
      <div
        className={`h-screen fixed rounded-l-lg border top-0 ${show ? 'right-0' : '-right-[320px]'} flex-row flex-nowrap overflow-hidden shadow-xl bg-secondary-100 w-80 z-[11] transition-all duration-300 p-6`}>


        <div className="flex items-center justify-between mb-4">
          <div className="text-lg font-bold">Info:</div>
          <CustomIcon icon="close" size="xl" className="cursor-pointer"
                      onClick={closeTips}/>
        </div>
        <div className="scrollbar h-[calc(100vh-80px)]">
        <_BlogSuggestions/>
          <div className="text-sm font-medium mb-3">Tips and Hints:</div>
          <div className="blog-tips">
            <div className="blog-tips-item">Click on the canvas to start adding and editing the contents.</div>
            <div className="blog-tips-item">Click on “+” icon to add new contents (Examples: Text, header, images,
              bullet etc...)
            </div>
            <div className="blog-tips-item flex space-x-1">
              <span>Click on</span>
              <CustomIcon size="lg"
                          className="cursor-pointer"
                          icon="drag_indicator"/>
              <span>for tuning the contents. </span>
            </div>
            <div className="blog-tips-item">Select text to change text formatting and add links.</div>
            <div className="blog-tips-item">All the empty elements will be automatically discarded.</div>


          </div>
        </div>
        
      </div>
      {show && <Backdrop className="z-10" onClick={closeTips}/>}
    </>
  );
};
export default BlogTips;


const _BlogSuggestions = () => {

  const title = useSelector((state) => state.manageBlogs.create.mainTitle);
  const blogContents = useSelector((state) => state.manageBlogs.create.content);


  const validity = blogContentValidityCheck(blogContents.blocks ?? []);
  return (
    <>
      <div className="blog-tips space-y-1">
        <_BlogCanvasValidatorItem title="Enter the main title of the blog." valid={!!title?.trim()} isVAlidationError={true}/>
        <_BlogCanvasValidatorItem
          title={`Add at-least ${MIN_CONTENT_NEEDED_IN_BLOGS} valid elements beside the main title.`}
          valid={validity.valid.length >= MIN_CONTENT_NEEDED_IN_BLOGS}  isVAlidationError={true}/>
        {!!validity.invalid.length &&
          <_BlogCanvasValidatorItem title="" invalids={validity.invalid}
                                    valid={false}  isVAlidationError={true}/>
        }

      </div>
      <div className="blog-tips">
        <div className="text-sm font-medium mt-4 mb-3">Requirements:</div>
        <_BlogCanvasValidatorItem title="Enter the main title of the blog." valid={!!title?.trim()}/>
        <_BlogCanvasValidatorItem
          title={`Add at-least ${MIN_CONTENT_NEEDED_IN_BLOGS} valid elements beside the main title.`}
          valid={validity.valid.length >= MIN_CONTENT_NEEDED_IN_BLOGS}/>     
      </div>      
    </>
  );
};

const _BlogCanvasValidatorItem = ({title, valid, invalids = [], isVAlidationError}) => {
  return (
    <>
    {!isVAlidationError ? 
      <div className={`blog-tips-item`}>
        {title}      
      </div> : 
      <>
        
         {
            !!invalids.length ?
            
            <>
            {
              invalids.map((inv, index) => 
              
              <div className="bg-rose-50 border border-rose-100 text-danger text-sm p-2 rounded" key={index}>
              <div className="flex items-start space-x-2">            
                <CustomIcon icon="error_outline" size="lg"/> 
                    <div>{inv.message}</div>
                </div>
                
              </div>
              )
            }
            </>
            :
           <>
            {!valid && 
              <div className="bg-rose-50 border border-rose-100 text-danger text-sm p-2 rounded">
                <div className="flex items-start space-x-2">                  
                  <CustomIcon icon="error_outline" size="lg"/> 
                  <div>{title}</div>
                </div>                
              </div>
              }
           </>
          }
      
      </>
    }
    </>
    
  );
};
